const LAST_READ_KEY = "chat_student_last_read_message_id";

let hasUnread = false;
const listeners = new Set();

function emit() {
   listeners.forEach((cb) => {
      try {
         cb();
      } catch {}
   });
}

export function getChatUnread() {
   return hasUnread;
}

export function markChatUnread() {
   if (hasUnread) return;
   hasUnread = true;
   emit();
}

export function clearChatUnread() {
   if (!hasUnread) return;
   hasUnread = false;
   emit();
}

export function subscribeChatUnread(cb) {
   listeners.add(cb);
   return () => listeners.delete(cb);
}

export function getLastReadChatMessageId() {
   if (typeof window === "undefined") return null;
   const raw = window.localStorage.getItem(LAST_READ_KEY);
   return raw != null && raw !== "" ? raw : null;
}

export function setLastReadChatMessageId(messageId) {
   if (messageId == null || typeof window === "undefined") return;
   window.localStorage.setItem(LAST_READ_KEY, String(messageId));
   clearChatUnread();
}

export function syncChatUnreadFromMessages(messages, { isStaffMessage }) {
   const list = Array.isArray(messages) ? messages : [];
   const last = list[list.length - 1];
   if (!last?.id || !isStaffMessage(last)) {
      clearChatUnread();
      return;
   }

   const lastRead = getLastReadChatMessageId();
   if (!lastRead || Number(last.id) > Number(lastRead)) {
      markChatUnread();
   } else {
      clearChatUnread();
   }
}
